import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
    children, 
    variant = 'primary', 
    size = 'normal', 
    to, 
    onClick,
    fullWidth = false,
    type = 'button'
}) => {
    const className = `btn btn--${variant} ${size === 'large' ? 'btn--large' : ''} ${fullWidth ? 'btn--full' : ''}`;

    if (to) {
        return (
            <Link to={to} className={className}>
                {children}
            </Link>
        );
    }

    return (
        <button type={type} className={className} onClick={onClick}>
            {children}
        </button>
    );
};

export default Button;
